"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualKeyboardEnum = exports.VirtualKeyboard = void 0;
const VirtualKeyboard = exports.VirtualKeyboard = {
  "USE VIRTUAL KEYBOARD": true,
  "NOT USE VIRTUAL KEYBOARD": false
};
const VirtualKeyboardEnum = exports.VirtualKeyboardEnum = {
  "NOT USE VIRTUAL KEYBOARD": 'NOT USE VIRTUAL KEYBOARD',
  "USE VIRTUAL KEYBOARD": 'USE VIRTUAL KEYBOARD'
};